module.exports = __webpack_public_path__ + "static/media/logo-dtls.14988820.svg";